<template>
  <div class="multi-section-container" v-if="cellList.length > 0">
      <div class="component-container">
        <h2 class="component-title" tabindex="0">
          <strong>{{getTitle()}}</strong>
        </h2>
        <div class="cell-container">
          <ul :class="containerClassName">
            <li v-for="(cell, index) in cellList" :key="'smr_' + bandType + index" @click.prevent="()=>goClip(cell)">
              <div :class="isPosterImage(cell) ? 'cell-img poster' : 'cell-img' + ' ' + $route.name">
                <img :src="getImageSrc(cell)" :key="'smr' + bandType + index"/>
                <age-tag v-if="cell.targetage !== '' && showAge(cell)" :age-code="cell.targetage"/>
                <div class="tag-bottom-time" v-if="cell.playtimetext !== '' && cell.playtimetext">
                  <span class="tag-time">{{cell.playtimetext}}</span>
                </div>
              </div>
              <div class="cell-info">
                <div class="cell-title-wrap">
                  <div class="cell-title">
                    <span class="title1 line2">{{cell.cliptitle}}</span>
                  </div>
                  <div class="cell-title">
                    <span class="title2 line1">{{cell.programtitle}}</span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
  </div>
</template>

<script>
import AgeTag from '@/components/tags/AgeTag'
import { resizeThumbnail } from '@/common/image.filter'
import { getBandTypeInfoBySmrCellType, getCellListContainerClassName } from '@/common/image.util'
import { PATH_NAME_PLAYER } from '@/common/router.const'
export default {
  name: 'SmrCellList',
  components: {
    AgeTag
  },
  props: {
    cellList: {
      type: Array
    },
    bandType: {
      type: String
    }
  },
  data () {
    return {
      thumbnailInfo: {},
      containerClassName: ''
    }
  },
  methods: {
    goClip (cell) {
      this.$router.push({
        name: PATH_NAME_PLAYER,
        params: {
          section: 'clip'
        },
        query: {
          clipid: cell.clipid
        }
      })
    },
    getImageSrc (cell) {
      if (this.isPosterImage(cell)) {
        return resizeThumbnail(cell.image, this.thumbnailInfo).replace('w320', 'w208').replace('h180', 'h296')
      } else {
        return resizeThumbnail(cell.image, this.thumbnailInfo)
      }
    },
    isPosterImage (cell) {
      return cell.image.indexOf('poster/') > -1
    },
    showAge (cell) {
      return cell.targetage === '19' || cell.targetage === '19+' || cell.targetage === '청불'
    },
    getTitle () {
      switch (this.bandType) {
        case 'popularlist':
          return '주목할만한 동영상'
        case 'clipPopularProgramList' :
          return '인기 프로그램'
        case 'newlist':
          return '최신영상'
      }
    }
  },
  created () {
    this.thumbnailInfo = getBandTypeInfoBySmrCellType(this.bandType)
    let popular = this.bandType === 'clipPopularProgramList' ? ' popular' : ''
    this.containerClassName = getCellListContainerClassName(this.thumbnailInfo.type) + popular
  }
}
</script>

<style scoped>
  .cell-img img {
    width: 100%;
    height: 100%;
  }
  img[lazy=loading] {
    opacity: 0.5;
  }
  img[lazy=error] {
    opacity: 1;
  }
  img[lazy=loaded] {
    -webkit-transition: opacity 350ms ease-in-out;
    -moz-transition: opacity 350ms ease-in-out;
    -o-transition: opacity 350ms ease-in-out;
    transition: opacity 350ms ease-in-out;
  }
  .popular .title1.line2{
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 1;
  }
</style>
